import classNames from 'classnames'
import ChartComponent from 'react-apexcharts'

import { getChartOptions } from './utils'

import './index.scss'

interface SparklineProps {
  data: number[]
  label: string
  categories: string[]
  customTooltip?: (props: any) => string
  subtitle?: string
  subtitleTooltip?: string
  disableTooltip?: boolean
  height?: number
  width?: number
  colors?: string[]
}

export default function Sparkline({
  data,
  label,
  categories,
  customTooltip,
  subtitle,
  subtitleTooltip,
  disableTooltip,
  height = 27,
  width = 76,
  colors,
}: Readonly<SparklineProps>) {
  const chartOption = getChartOptions({ tooltip: customTooltip, colors })

  return (
    <div className="SparklineComponentWrapper">
      <ChartComponent
        className="chartComponent"
        type="line"
        height={height}
        width={width}
        series={[
          {
            data,
            name: label,
          },
        ]}
        options={{
          ...chartOption,
          xaxis: { categories },
          tooltip: {
            ...chartOption.tooltip,
            enabled: !disableTooltip,
          },
        }}
      />
      {subtitle && (
        <div
          className={classNames(['SparklineComponentSubtitle', { 'tooltipped tooltipped-s': !!subtitleTooltip }])}
          aria-label={subtitleTooltip}
        >
          {subtitle}
        </div>
      )}
    </div>
  )
}
